import * as $ from 'jquery';
import 'eonasdan-bootstrap-datetimepicker';
import '../../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
import './datetime-picker.less';

declare global {
    interface JQuery {
        datetimepicker(any): any;
    }
}

export interface DateTimePickerOptions {
    input: string | HTMLElement,
    minDate: string,
    maxDate: string,
    defaultDate: string,
    showTimePicker: boolean,
    dateFormat: string
}

export class DateTimePickerService {
    static initDateTimePicker(dtPickerOptions: DateTimePickerOptions, onChange?: Function) {
        let options = {};
        let input = $(dtPickerOptions.input as any);
        if (dtPickerOptions.minDate) {
            (options as any).minDate = dtPickerOptions.minDate;
        }
        if (dtPickerOptions.maxDate) {
            (options as any).maxDate = dtPickerOptions.maxDate;
        }
        if (dtPickerOptions.defaultDate) {
            (options as any).defaultDate = dtPickerOptions.defaultDate;
        }
        if (input.data("DateTimePicker")) {
            input.data("DateTimePicker").destroy();
        }
        (options as any).format = dtPickerOptions.dateFormat;
        if (dtPickerOptions.showTimePicker)
            (options as any).format = dtPickerOptions.dateFormat + " HH:mm";

        let dt = input.datetimepicker(options);
        if (onChange)
            dt.on("dp.change", onChange);
    }
}